<template>
  <div>
    <!-- <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                :enableExportAllIssue="true"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @exportAllXlsIssue="exportAllXlsIssue"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
           <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <CForm>
        <CRow>
          <!-- <CCol sm="3">
            <CInput disabled label="Issue Code" invalid-feedback="Issue Code should be filled" required v-model="$v.productIssueForm.issue_code.$model" :is-valid="!$v.productIssueForm.issue_code.$invalid"/>
          </CCol> -->
              <CCol sm="3">
                <div class="form-group">
                  <label for="Product">Product</label>
                  <model-select
                    class="form-control"
                    id="Product"
                    :options="productList"
                    v-model="$v.productIssueForm.product_code.$model"
                    :isError="$v.productIssueForm.product_code.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.productIssueForm.product_code.$invalid"
                    class="invalid-feedback-custom"
                  >Product should be filled.</div>
                </div>
              </CCol>

          <CCol sm="3">
            <div class="form-group">
              <label for="Issue">Issue</label>
              <model-select
                class="form-control"
                id="issue"
                :options="issueList"
                v-model="$v.productIssueForm.issue_type.$model"
                :isError="$v.productIssueForm.issue_type.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.productIssueForm.issue_type.$invalid"
                class="invalid-feedback-custom"
              >Product should be filled.</div>
            </div>
          </CCol>

          <CCol sm="3">
            <div class="form-group">
              <label for="user">user</label>
              <model-select
                class="form-control"
                id="user"
                :options="userList"
                v-model="$v.productIssueForm.user_code.$model"
                :isError="$v.productIssueForm.user_code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.productIssueForm.user_code.$invalid"
                class="invalid-feedback-custom"
              >Product should be filled.</div>
            </div>
          </CCol>

        </CRow>
        <CRow>
          <CCol sm="9">
            <label for="nik">Description</label>
            <quill-editor style="height: 200px; margin-bottom:70px;"
              :content="content"
              :options="editorOption"
              v-model="$v.productIssueForm.description.$model"
              @change="onEditorChange($event)">
            </quill-editor>
            <br/>
            <div v-if="$v.productIssueForm.description.$invalid" class="invalid-feedback-custom">
              Description harus di isi.
            </div>
            <!-- <CTextarea required rows="4" label="Description" invalid-feedback="Description should be filled" v-model="$v.productIssueForm.description.$model" :is-valid="!$v.productIssueForm.description.$invalid"/> -->
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.productIssueForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "@/templates/Loading";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "ProductIssue",
  components: { quillEditor, Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Masalah Produk",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "issue_code", type: "string" },
          { name: "product_name", type: "string" },
          { name: "issue_type_name", type: "string" },
          { name: "description", type: "string" },
          { name: "user_name", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      productList: [],
      issueList: [],
      userList: [],

      fields: [
        {
          datafield: "issue_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode Masalah",
        },
        {
          datafield: "product_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Produk",
        },
        {
          datafield: "issue_type_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Tipe Masalah",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Deskripsi",
        },
        {
          datafield: "user_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "User",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        }
      ],

      listBoxSource: [
        {
          label: "Tipe Masalah",
          value: "issue_type_name",
          checked: true,
        },
        {
          label: "Deskripsi",
          value: "description",
          checked: true,
        },
        {
          label: "User",
          value: "user_name",
          checked: true,
        }
      ],

      items: null,
      productIssueForm: tableInterfaces.product_issue,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: '',editorOption: {},	// data quill
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    productIssueForm: {
      issue_code: { },
      issue_type: { required },
      product_code: { required },
      user_code: { required },
      description: { required },
      date_inserted: { },
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportAllXlsIssue: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function() {
      this.isEdit = false;
      this.cancelForm();
      this.getDropdown();
      this.getProductIssue();
    },
    getProductIssue: function() {
      this.isLoading = true;
      this.axios.get("console/product_issue/listing").then(response => {
        if (response.data.status === 2000) {
          //this.items = response.data.data;
          const temp = this.source;
          temp.localdata = response.data.data;
          this.items = new jqx.dataAdapter(temp);

          this.showInfoNotification({
            title: this.title,
            message: response.data.message
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message
          });
        }
      })
      .catch(error => {
        this.showErrorNotification({
          title: this.title,
          message: error
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    getDropdown: function() {
      this.axios.get("/console/product_issue/dropdown").then(response => {
        this.productList = response.data.product;
        this.issueList = response.data.issued_type;
        this.userList = response.data.users;
      });
    },
    addForm: function() {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function() {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function(item) {
      this.addForm();
      this.isEdit = true;
      this.productIssueForm = item;
    },
    resetForm: function() {
      for (var i in tableInterfaces.product_issue) {
        tableInterfaces.product_issue[i] = null;
      }
      this.productIssueForm = tableInterfaces.product_issue;
    },
    submitForm: function(event) {
      event.preventDefault();
      if (confirm("Do you want to add this data ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios.post("console/product_issue/add", this.productIssueForm).then(response => {
          if (response.data.status === 2000) {
            this.showInfoNotification({
              title: this.title,
              message: response.data.message
            });
            this.$router.push({ path: path[2]+"/detail/" + response.data.id });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message
            });
          }
        }).catch(error => {
          this.showErrorNotification({
            title: this.title,
            message: error
          });
        }).finally(() => {
          this.isLoading = false;
          this.init();
        });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.productIssueForm.description = html
    },
  },
  mounted() {
    this.init();
  }
};
</script>
